import React from 'react';
import waIcon from '../assets/waicon.png'; // esta vez solo es una imagen

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/526671743222"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <img src={waIcon} alt="WhatsApp" />
    </a>
  );
};

export default WhatsAppButton;